// import "./utils/consoleWarning";
import { createRoot } from "react-dom/client";
// import { StrictMode } from "react";
import "./utils/i18n";
import "./utils/mapboxGlyphs";
import Root from "./Root";

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <Root />
  // </StrictMode>
);
